export const CancellationConsts = {
    NOTE_MAX_LENGTH: 1024,
};
